<template>
  <InputMask
    :name="context?.node.name"
    :modelValue="context?._value"
    @update:modelValue="(v: string) => context?.node.input(v)"
    @blur="() => context?.handlers.blur()"
    :disabled="context?.disabled"
    :placeholder="context?.attrs.placeholder"
    :mask="context?.attrs.mask"
    :slotChar="context?.attrs.placeholder"
    v-bind="inputMaskPassThrough"
  />
</template>

<script setup lang="ts">
import InputMask from 'primevue/inputmask'

const props = defineProps({
  context: Object,
})

const inputMaskPassThrough = {
  pt: {
    root: {
      class: props.context?.classes.input,
      id: props.context?.id,
      autocomplete: props.context?.attrs.autocomplete ?? null,
    },
  },
}
</script>
